import styled from 'styled-components'
import { ModalProps } from './interfaces'

export const Container = styled.div<ModalProps>`
  :after {
    position: ${({ $open }) => ($open ? 'absolute' : 'unset')};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    content: '';
    z-index: ${({ theme }) => theme.zIndex.absolute};
  }
`
export const ModalAside = styled.div`
  position: fixed;
  transform-origin: right;
  transition-delay: 0.1s;
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  transform: scaleX(0.6);
  opacity: 0;

  &.animated {
    transform: scaleX(1);
    opacity: 1;
  }

  padding-top: 50px;
  padding-left: 54px;
  height: 100%;
  width: calc(100% - 72px);
  right: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.color.background.neutral.default};
  overflow: auto;
  overflow-x: hidden;

  @media screen and (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    padding: ${({ theme }) => `${theme.spacing.km0}`};
    width: 100%;
  }
`

export const ActionSection = styled.div``

export const Title = styled.h1`
  color: #111111;
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 110%;
  text-align: center;
`
